<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <router-link class="navbar-brand" to="/">
        <img src="@/assets/images/logo_navbar.png" alt="logo">
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarContent"
        aria-controls="navbarContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center" style="gap: 0.75rem;">
          <li class="nav-item" v-if="auth">
            <div class="nav-user">
              <div class="nav-user__avatar">
                <i class="pi pi-user"></i>
              </div>
              <span class="nav-user__name">لوحة التحكم</span>
            </div>
          </li>
          <li class="nav-item" v-if="auth">
            <button class="theme-toggle-btn" type="button" @click="toggleTheme" :title="isDark ? 'تفعيل الوضع الفاتح' : 'تفعيل الوضع الداكن'">
              <i :class="isDark ? 'pi pi-sun' : 'pi pi-moon'"></i>
            </button>
          </li>
          <li class="nav-item" v-if="auth">
            <button class="nav-logout-btn" type="button" @click="logout">
              <i class="pi pi-sign-out"></i>
              <span>تسجيل خروج</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      auth: false,
    }
  },
  computed: {
    isDark() {
      return this.$store.getters["currentTheme"] === "dark";
    }
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      location.reload();
    },
    toggleTheme() {
      const next = this.isDark ? "light" : "dark";
      this.$store.dispatch("setTheme", next);
    }
  },
  created() {
    this.auth = this.$store.getters["isAuthenticated"];
  }
}
</script>

<style scoped>
.theme-toggle-btn {
  background: transparent;
  border: 1px solid var(--gold);
  color: var(--gold);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  font-size: 1rem;
}
.theme-toggle-btn:hover {
  background: var(--gold);
  color: var(--btn-on-gold, #0F0F0F);
}
</style>
